(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dart-rate-calculator"] && !Shopify.designMode) return;
  try {
    
(() => {
  const totalNumber = document.getElementById('total_number');
  const hoursWorked = document.getElementById('hours_worked');
  const incidentRate = document.getElementById('incident_rate');
  const result = document.getElementById('incident_rate_result');

  if (!totalNumber || !hoursWorked || !incidentRate || !result) return;

  const compute = () => {
    const total = parseFloat(totalNumber.value);
    const hours = parseFloat(hoursWorked.value);
    const normalizedTotal = total > 0 ? total : 1;
    const normalizedHours = hours > 0 ? hours : 28400;
    const rate = ((normalizedTotal * 200000) / normalizedHours).toFixed(2);

    incidentRate.value = rate;
    result.textContent = rate;
  };

  [totalNumber, hoursWorked].forEach((input) => {
    input.addEventListener('input', compute);
    input.addEventListener('change', compute);
  });

  totalNumber.closest('form')?.addEventListener('submit', (event) => event.preventDefault());
  compute();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lost-time-case-rate-calculator"] && !Shopify.designMode) return;
  try {
    
(() => {
  const totalNumber = document.getElementById('total_number');
  const hoursWorked = document.getElementById('hours_worked');
  const incidentRate = document.getElementById('incident_rate');
  const result = document.getElementById('incident_rate_result');

  if (!totalNumber || !hoursWorked || !incidentRate || !result) return;

  const compute = () => {
    const total = parseFloat(totalNumber.value);
    const hours = parseFloat(hoursWorked.value);
    const normalizedTotal = total > 0 ? total : 1;
    const normalizedHours = hours > 0 ? hours : 28400;
    const rate = ((normalizedTotal * 200000) / normalizedHours).toFixed(2);

    incidentRate.value = rate;
    result.textContent = rate;
  };

  [totalNumber, hoursWorked].forEach((input) => {
    input.addEventListener('input', compute);
    input.addEventListener('change', compute);
  });

  totalNumber.closest('form')?.addEventListener('submit', (event) => event.preventDefault());
  compute();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osha-incident-rate-calculator"] && !Shopify.designMode) return;
  try {
    
(() => {
  const totalNumber = document.getElementById('total_number');
  const hoursWorked = document.getElementById('hours_worked');
  const incidentRate = document.getElementById('incident_rate');
  const result = document.getElementById('incident_rate_result');

  if (!totalNumber || !hoursWorked || !incidentRate || !result) return;

  const compute = () => {
    const total = parseFloat(totalNumber.value);
    const hours = parseFloat(hoursWorked.value);
    const normalizedTotal = total > 0 ? total : 2;
    const normalizedHours = hours > 0 ? hours : 28400;
    const rate = ((normalizedTotal * 200000) / normalizedHours).toFixed(2);

    incidentRate.value = rate;
    result.textContent = rate;
  };

  [totalNumber, hoursWorked].forEach((input) => {
    input.addEventListener('input', compute);
    input.addEventListener('change', compute);
  });

  totalNumber.closest('form')?.addEventListener('submit', (event) => event.preventDefault());
  compute();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcr-and-dart-rate-calculator"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bindCalculator = (prefix) => {
    const totalNumber = document.getElementById(prefix + '_total_number');
    const hoursWorked = document.getElementById(prefix + '_hours_worked');
    const incidentRate = document.getElementById(prefix + '_incident_rate');
    const result = document.getElementById(prefix + '_incident_rate_result');

    if (!totalNumber || !hoursWorked || !incidentRate || !result) return;

    const compute = () => {
      const total = parseFloat(totalNumber.value);
      const hours = parseFloat(hoursWorked.value);
      const normalizedTotal = total > 0 ? total : 1;
      const normalizedHours = hours > 0 ? hours : 28400;
      const rate = ((normalizedTotal * 200000) / normalizedHours).toFixed(2);

      incidentRate.value = rate;
      result.textContent = rate;
    };

    [totalNumber, hoursWorked].forEach((input) => {
      input.addEventListener('input', compute);
      input.addEventListener('change', compute);
    });

    compute();
  };

  bindCalculator('tcr');
  bindCalculator('dart');
  document.querySelector('.tcr-and-dart-rate-calculator form')?.addEventListener('submit', (event) => event.preventDefault());
})();

  } catch(e) { console.error(e); }
})();
})();
